import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=ec8476da&scoped=true"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"
import style0 from "./EditEvent.vue?vue&type=style&index=0&id=ec8476da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8476da",
  null
  
)

export default component.exports